import { useState } from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useToast } from 'components/hooks/useToast';
import { useHistory } from 'react-router-dom';

import { TOAST_STATUSES } from 'constants/ProjectConstants';
import { StringModifier, modifyString } from 'constants/copyHelpers';
import { getObjectiveDetailsRoute, getTaskDetailsRoute } from 'constants/helper';

import { OKR_TYPES } from '../PrimaryPanel/Sections/Overview/ParentOKR';
import { useCloneOKRMutation } from '../datahooks/useCloneOKRMutation';
import { useOKRDrawerControlCallbacks } from '../useOKRDrawerControlCallbacks';

/* currently only works when bottom drawer is open */
export const useOKRCloneModalLogic = ({ okrDetails }) => {
  const history = useHistory();
  const toast = useToast();

  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const isObjective = okrDetails?.type === OKR_TYPES.OBJECTIVE;

  const openClonedOKRPanel = (clonedOKRId, clonedOKRType = 'GOAL') => {
    const isObjective = clonedOKRType === OKR_TYPES.OBJECTIVE;

    if (isObjective) {
      const route = getObjectiveDetailsRoute({
        location: history.location,
        objectivePId: clonedOKRId,
      });
      history.push(route);
    } else {
      const route = getTaskDetailsRoute({
        location: history.location,
        ids: [clonedOKRId],
        type: 'GOAL',
      });
      history.push(route);
    }
  };

  const [isCloneModalOpen, setIsCloneModalOpen] = useState(false);

  const { onUpdate } = useOKRDrawerControlCallbacks();

  const { mutate } = useCloneOKRMutation();

  const closeCloneModal = () => {
    setIsCloneModalOpen(false);
  };

  const openCloneModal = () => {
    setIsCloneModalOpen(true);
  };

  const cloneOKR = async ({ okrDetails, cloneBothChildObjectivesAndKRs, cloneOnlyChildObjectives }) => {
    mutate(
      {
        okrDetails,
        cloneBothChildObjectivesAndKRs,
        cloneOnlyChildObjectives,
      },
      {
        onError: (err) => {
          toast({
            title:
              err.message ||
              `The ${
                isObjective
                  ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
                  : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)
              } could not be cloned`,
            status: TOAST_STATUSES.ERROR,
            position: 'bottom-left',
          });
        },
        onSuccess: (data) => {
          const clonedOKRId = data?.entity;

          if (typeof onUpdate === 'function') {
            console.log('inside onUpdate');
            onUpdate();
          }

          toast({
            title: `The ${
              isObjective
                ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
                : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)
            } have been successfully cloned`,
            status: TOAST_STATUSES.SUCCESS,
            position: 'bottom-left',
          });
          closeCloneModal();
          openClonedOKRPanel(clonedOKRId, okrDetails?.type);
        },
      }
    );
  };

  const handleCloneNoChildren = () => {
    cloneOKR({
      okrDetails,
      cloneBothChildObjectivesAndKRs: false,
      cloneOnlyChildObjectives: false,
    });
  };

  const handleCloneChildObjectives = () => {
    cloneOKR({
      okrDetails,
      cloneBothChildObjectivesAndKRs: false,
      cloneOnlyChildObjectives: true,
    });
  };

  const handleCloneAllChildren = () => {
    cloneOKR({
      okrDetails,
      cloneBothChildObjectivesAndKRs: true,
      cloneOnlyChildObjectives: false,
    });
  };

  return {
    isCloneModalOpen,
    openCloneModal,
    closeCloneModal,
    handleCloneNoChildren,
    handleCloneChildObjectives,
    handleCloneAllChildren,
  };
};
